// Admin panel feature flags — flip a value to re-enable a stashed section.
// Developer-level switch, code-reviewed like any other change; no runtime UI.
export const ADMIN_FEATURE_FLAGS = Object.freeze({
  overview: false, // AdminOverviewSection
  workflowGuide: false, // AdminWorkflowNav + AdminWorkflowGuide (DDAT phase nav)
  agentRequests: false, // AdminRequestsSection
  adBanners: true, // AdminAdsSection (site ad banners moderation + pricing)
  reviewModeration: true, // AdminReviewsSection (list + delete property/seller reviews)
  partnerShowcase: true, // AdminPartnerShowcaseSection (Become-a-Partner hero carousel moderation)
  knowledgeBase: true, // AdminKnowledgeBaseSection (Help Centre article management)
});
